module.exports = __webpack_public_path__ + "static/media/logo-menu.bc1a5f10.png";